module.exports = __webpack_public_path__ + "static/mreis@2x-5aa6fd4570e47f5ba3b81a441d865c69.jpg";